import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Steps from './steps';
import StepImage from './stepImage';
import './HowToPage.css'
import { tutorials } from '../Data/TutorialData';
import logo from "../TestImages/StediAppIcon5.png";
// import createProspect from './AppScreenshots/CreateProspect/CreateProspect1.jpg';

function HowToPage() {
    const { slug } = useParams();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
      const container = document.querySelector('.main-content');
      if (container) {
        container.scrollTop = 0;
      }
    }, []);

    const tutorial = tutorials.find(
        tut => tut.title.toLowerCase().replace(/\s+/g, '-') === slug
    );

    if (!tutorial) {
        return <div>Sorry, no details found for this tutorial.</div>;
      }

    return (
        <div className="how-to-container">
          {/* <div className="how-to-header"> */}
            {/* <img className="how-to-logo" src={logo} alt=''/> */}
            <h1 className='how-to-title'>{tutorial.title}</h1>
          {/* </div> */}
          
          {tutorial.steps.map((step, index) => (
            <div key={index}>
              <Steps stepContent={step.text} />
              {step.images && step.images.length > 0 && (
                <div className="step-images">
                 {step.images.map((imageName, imgIndex) => {
                    return (
                        <StepImage key={imgIndex} image={imageName} />
                    ) 
                })}
                </div>
              )}
            </div>
          ))}
        </div>
    );
}

export default HowToPage;
